<div>
  <span><ng-content></ng-content></span>
  <ng-content select="opac-button"></ng-content>
</div>
